module.exports = __webpack_public_path__ + "public/img/1.3d9a4ed6.png";